export default "__VITE_ASSET__bd9c7fc9__"